import {useActions} from "../../../hook/useActions";
import styles from "./GroupsList.module.scss";
import {useEffect, useState} from "react";
import {useTypedSelector} from "../../../hook/useTypedSelector";
import {useNavigate} from "react-router-dom";

function AllGroups() {
    const {allGroups} = useTypedSelector((store) => store.curatorialGroup);
    const {allUsers} = useTypedSelector((store) => store.user);
    const [groups, setGroups] = useState<any[]|undefined>(undefined);
    const {GetGroups, GetAllUsersAsync, AddGroup, DeleteGroupById} = useActions();
    const navigate = useNavigate();

    useEffect(() => {
        GetGroups();
        GetAllUsersAsync();
    }, []);

    useEffect(() => {
        if (allGroups && allUsers) {
            const usersMap = new Map(allUsers.map((user: any) => [user.id, user]));
            let array:any[] = [];
            allGroups.forEach((group: any) => {
                const data = {
                    ...group,
                    curator: usersMap.get(group.curatorId) || null,
                    listeners: group.listenersId.map((id: string) => usersMap.get(id)).filter((user: any) => user),
                }
                array.push(data);
            });
            setGroups(array);
            console.log(array);
        }
    }, [allGroups, allUsers]);

    if(!groups) {
        return <div>Loading...</div>;
    }

    function handleAddClick() {
        AddGroup({curatorId: ""});
        GetGroups();
    }

    return <div className={styles.container}>
        <h2>Curatorial Groups</h2>
        <button style={{width: "150px", marginBottom: "10px"}} onClick={handleAddClick}>Add Group</button>
        <table className={styles.table}>
            <thead>
            <tr>
                <th>Group ID</th>
                <th>Curator</th>
                <th>Listeners</th>
                <th>Options</th>
            </tr>
            </thead>
            <tbody>
            {groups.map((group: any) => (
                <tr key={group.id}>
                    <td>{group.id}</td>
                    <td>{group.curator ? group.curator.fullName : "None"}</td>
                    <td>
                        {group.listeners && group.listeners.length > 0 ? (
                            group.listeners.map((listener: any, index: number) => (
                                <div key={index}>
                                    {listener.fullName}
                                </div>
                            ))
                        ) : (
                            <span>No listeners</span>
                        )}
                    </td>
                    <td>
                        <button onClick={() => navigate("/admin/edit-group?id=" + group.id)}>Edit Members</button>
                        <button onClick={() => DeleteGroupById(group.id)}>Delete</button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>;
}

export default AllGroups;